var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_40087",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 40087",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80.201 91.399"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25373",
    "data-name": "\\u30D1\\u30B9 25373",
    d: "M67.824,11.527h-16.2L40.1,0,28.573,11.527h-16.2A12.391,12.391,0,0,0,0,23.9V31.33H4.951V23.9a7.434,7.434,0,0,1,7.426-7.426H30.624L40.1,7l9.477,9.477H67.824A7.434,7.434,0,0,1,75.25,23.9V79.022a7.434,7.434,0,0,1-7.426,7.426H12.377a7.434,7.434,0,0,1-7.426-7.426V36.281H0V79.022A12.391,12.391,0,0,0,12.377,91.4H67.824A12.391,12.391,0,0,0,80.2,79.022V23.9A12.391,12.391,0,0,0,67.824,11.527Z",
    transform: "translate(80.201 91.399) rotate(180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25376",
    "data-name": "\\u30D1\\u30B9 25376",
    d: "M190.5,202.5h4.951v4.951H190.5Z",
    transform: "translate(-127.626 -180.22)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25379",
    "data-name": "\\u30D1\\u30B9 25379",
    d: "M190.5,172.5h4.951v4.951H190.5Z",
    transform: "translate(-127.626 -160.122)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25381",
    "data-name": "\\u30D1\\u30B9 25381",
    d: "M86.905,204.615a16.96,16.96,0,1,0,10.247,30.478l4.349,4.349,3.5-3.5-4.383-4.383a16.964,16.964,0,0,0-13.714-26.944ZM97.057,228l-4.823-4.823-3.5,3.5,4.871,4.871A12,12,0,1,1,97.057,228Z",
    transform: "translate(-46.861 -181.639)"
  })));
};
export default SvgQuestion;